import { getTelegramWebApp } from "./telegram";

function authHeaders(): HeadersInit {
  const initData = getTelegramWebApp()?.initData ?? "";
  return { Authorization: `tma ${initData}` };
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(path, { headers: authHeaders() });
  if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
  return (await res.json()) as T;
}

export async function apiDelete(path: string): Promise<void> {
  const res = await fetch(path, { method: "DELETE", headers: authHeaders() });
  if (!res.ok) throw new Error(`DELETE ${path} failed: ${res.status}`);
}
